import React, { useMemo } from 'react';
import { Skeleton, TableCell, TableRow } from '@mui/material';

import { useAppSelector } from 'store/hooks';
import { RootState } from 'store/types';

import useStyles from '../styles';

const TableLoader: React.FC = () => {
  const classes = useStyles();
  const { rowsPerPage, columns } = useAppSelector((state: RootState) => state.table);

  const loadingArray = useMemo(() => {
    return new Array(rowsPerPage).fill(1);
  }, [rowsPerPage]);

  return (
    <>
      {loadingArray.map(() => (
        <TableRow key={crypto.randomUUID()} className={classes.tableRow}>
          {columns.map(() => (
            <TableCell key={crypto.randomUUID()} className={classes.tableCell}>
              <Skeleton className={classes.tableCell} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default TableLoader;
